export default __webpack_public_path__ + "static/pepsi-stop-e1193c3255f6daf070ce180e4269a60c.png";